// extracted by mini-css-extract-plugin
module.exports = {"root":"snippet-tags_root__q4cpt","leftIcon":"snippet-tags_leftIcon___T0_8"};